<template>
  <div
    :id="id"
    class="d-none d-lg-block col-lg-3 text-uppercase text-small"
    data-html="true"
    :title="newTitle"
    @mouseover="tooltipToggle(true)"
    @mouseleave="tooltipToggle(false)"
  >
    <div class="row">
      <div class="col-1">
        <fa-icon icon="info-circle" />
      </div>
      <div class="col-9 p-1">
        Prueba de {{ title }}
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';

export default {
    name: 'HeaderFavoritesTable',
    props: {
        id: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            modalDelete: false,
        };
    },
    computed: {
        newTitle() {
            return `Puntaje promedio en <b> Prueba Nacional </b> de <b>${this.title} de los egresados de esta carrera</b>`;
        },
    },
    methods: {
        tooltipToggle(on) {
            if (on) {
                $(`#${this.id}`).tooltip('show');
            } else {
                $(`#${this.id}`).tooltip('hide');
            }
        },
    },
};
</script>
